import isNode from 'detect-node';
export var env = {
  isNode: isNode,
  forceCache: false
};